import { FC } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import type { Store } from 'src/redux/types/storeTypes';
import { Carousel } from 'components/dynamic';
import { ViewerDevice } from 'constants/enums';

import styles from './CustomizableMobileSlider.module.scss';
import { ListBlock } from './Block';

import type { IBlocks } from '../config/declarations';

import 'react-responsive-carousel/lib/styles/carousel.min.css';

export const Blocks: FC<IBlocks> = ({ blocks }) => {
  const viewerDevice = useSelector((store: Store) => store.server.app.viewerDevice);

  if (!blocks) {
    return null;
  }

  if (viewerDevice === ViewerDevice.MOBILE || viewerDevice === ViewerDevice.TABLET) {
    return (
      <Carousel
        className={styles.blocks}
        showThumbs={false}
        showStatus={false}
        showArrows={false}
        infiniteLoop
        emulateTouch
        autoPlay
      >
        {blocks.map((block) => (
          <div key={block.sys.id} className={styles.carouselSlide}>
            <ListBlock block={block} tag="div" />
          </div>
        ))}
      </Carousel>
    );
  }

  const blocksAmount = blocks.length > 5 ? 5 : blocks.length;

  return (
    <ul className={cn(styles.blocks, styles[`blocks${blocksAmount}`])}>
      {blocks.map((block) => (
        <ListBlock key={block.sys.id} block={block} />
      ))}
    </ul>
  );
};
